export class PublicCartSummary {
  public constructor(
    private readonly data: {
      totalItemsPrice: number;
      totalPrice: number;
    },
  ) {}
  public get totalItemsPrice(): number {
    return this.data.totalItemsPrice;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }
}
